function SET_VACANCY(state, payload) {
    state.vacancy = payload;
};

export {
    SET_VACANCY,
};